module.exports = __webpack_public_path__ + "static/a-xx-154-art-45ce5ddea06b6aed9a54c2e6e4c63709.jpg";